import React, { useState } from 'react'
import moment from 'moment'
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import API from '../../../../services/API'
import AnDateTimePicker from '../../../../components/DateTime/DateTimePicker'

const lateClockoutReasons = [
  'Patient Handover Delay',
  'Journey Overran',
  'Emergency Delay',
  'Traffic / Travel Delay',
  'Vehicle Issue',
  'Additional Journey Added',
  'Patient Required Additional Assistance',
  'Hospital Delay',
  'Waiting for Crew Relief',
  'Paperwork / Documentation',
  'Equipment / Vehicle Clean Down',
  'Manager Request',
  'IT / System Issue',
  'Other',
]

const LateFinish = ({
  shiftID,
  expectedTime,
  needsLateFinishReason,
  setNeedsLateFinishReason,
  loadActiveShift,
}) => {
  const [reason, setReason] = useState(null)
  const [otherReason, setOtherReason] = useState('')
  const [correctedTime, setCorrectedTime] = useState(null)
  const shouldCollectActualFinishTime =
    reason && reason !== 'Forgot to Clock Out'
  const expectedTimeText = moment(expectedTime).isSame(moment(), 'day')
    ? moment(expectedTime).format('HH:mm')
    : moment(expectedTime).format('DD/MM/YYYY HH:mm')

  const handleSubmit = (e) => {
    e.preventDefault()

    const finishTime = shouldCollectActualFinishTime
      ? moment(correctedTime ?? moment())
      : moment(expectedTime)
    const minTime = moment(expectedTime)
    const maxTime = moment()

    if (shouldCollectActualFinishTime) {
      if (!finishTime.isValid()) return

      if (finishTime.isBefore(minTime) || finishTime.isAfter(maxTime)) {
        return
      }
    }

    const payload = {
      shiftID,
      ...(reason && { lateFinishReason: reason }),
      ...(shouldCollectActualFinishTime && {
        correctedTime: finishTime.toISOString(),
      }),
      ...(otherReason && { otherReason }),
    }
    API.post('/shift-clock-out', { ...payload }).then((res) => {
      if (res.status === 200) {
        loadActiveShift()
        setNeedsLateFinishReason(false)
      }
    })
  }

  return (
    <Dialog
      open={!!needsLateFinishReason}
      onClose={() => setNeedsLateFinishReason(false)}
      component="form"
      onSubmit={handleSubmit}
    >
      <DialogTitle>
        <Stack gap={1}>
          <Typography variant="title3">Late Finish Reason</Typography>
          <Typography variant="caption">
            Your shift was due to end at {expectedTimeText}. Please select the
            reason for the late finish below.
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack gap={2} mt={1}>
          <Autocomplete
            options={['Forgot to Clock Out', ...lateClockoutReasons]}
            renderInput={(params) => (
              <TextField {...params} required label="Reason" />
            )}
            value={reason}
            onChange={(e, newValue) => setReason(newValue)}
            disableClearable
          />
          {shouldCollectActualFinishTime && (
            <AnDateTimePicker
              value={correctedTime ?? moment()}
              onChange={(newDate) => setCorrectedTime(newDate)}
              default={expectedTime}
              required
              label="Actual Finish Time"
              minDateTime={moment(expectedTime)}
              maxDateTime={moment()}
            />
          )}
          {reason === 'Other' && (
            <TextField
              required
              label="Other Reason"
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => setNeedsLateFinishReason(false)}
          color="error"
        >
          Cancel
        </Button>
        <Button variant="success" type="submit" variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LateFinish
